module.exports = __webpack_public_path__ + "fonts/icomoon-ca38fc.svg";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/icomoon.svg?v=1.0.0
// module id = 815
// module chunks = 2